package com.yet.tetris.database

import app.cash.sqldelight.ColumnAdapter
import com.yet.tetris.domain.model.game.TetrominoType
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class CurrentGameState(
  public val id: Long,
  public val score: Long,
  public val linesCleared: Long,
  public val level: Long,
  public val piecesPlaced: Long,
  public val maxCombo: Long,
  public val tetrisesCleared: Long,
  public val tSpinClears: Long,
  public val perfectClears: Long,
  public val hardDrops: Long,
  public val hardDropCells: Long,
  public val softDropCells: Long,
  public val backToBackChain: Long,
  public val isTSpinEligible: Boolean,
  public val currentPieceType: TetrominoType?,
  public val currentPieceRotation: Long,
  public val currentPositionX: Long,
  public val currentPositionY: Long,
  public val nextPieceType: TetrominoType,
  public val nextPieceRotation: Long,
  public val nextQueue: String,
  public val holdPieceType: TetrominoType?,
  public val holdPieceRotation: Long,
  public val canHold: Boolean,
  public val isGameOver: Boolean,
  public val isPaused: Boolean,
  public val boardWidth: Long,
  public val boardHeight: Long,
) {
  public class Adapter(
    public val currentPieceTypeAdapter: ColumnAdapter<TetrominoType, String>,
    public val nextPieceTypeAdapter: ColumnAdapter<TetrominoType, String>,
    public val holdPieceTypeAdapter: ColumnAdapter<TetrominoType, String>,
  )
}
